import { createPageApp } from '@/lib/createPageApp'
import ViewUnit2Page from './ViewUnit2Page.vue'

createPageApp(ViewUnit2Page).mount()
